module.exports = __webpack_public_path__ + "img/logo-dark-desktop.b77510dc.svg";